(function () {
  function animateAccordion(details, opening) {
    const content = details.querySelector('.accordion__content');
    if (!content) return;

    if (details._anim) details._anim.cancel();

    if (opening) {
      details.setAttribute('open', '');
      const h = content.scrollHeight;
      details._anim = content.animate(
        [{ height: '0px', overflow: 'hidden' }, { height: h + 'px', overflow: 'hidden' }],
        { duration: 350, easing: 'ease' }
      );
      details._anim.onfinish = () => { details._anim = null; };
    } else {
      const h = content.scrollHeight;
      details._anim = content.animate(
        [{ height: h + 'px', overflow: 'hidden' }, { height: '0px', overflow: 'hidden' }],
        { duration: 350, easing: 'ease' }
      );
      details._anim.onfinish = () => { details.removeAttribute('open'); details._anim = null; };
    }
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.accordion summary');
    if (!summary) return;
    var details = summary.closest('details');
    if (!details) return;
    e.preventDefault();
    animateAccordion(details, !details.open);
  });
})();
